<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = null,
		disabled = null,
		error = null,
		label = null,
		onchange = null,
		...props
	} = $props();

	let checked = $state(value ? true : false);

	$effect(() => {
		value = checked ? true : false;
	});
</script>

<!-- TODO: we are currently treating checkboxes as a single input, but they should be treated as a group of inputs -->
<InputWrapper class={className} {error}>
	<label class="grid grid-flow-col grid-cols-[auto_1fr] items-center">
		<input
			bind:this={element}
			value="true"
			type="checkbox"
			class={[
				`
      mr-2 form-checkbox! size-8 content-center rounded-md
      border-indow-grey-light text-indow-blue ring ring-indow-white
      focus:border-indow-grey focus:ring-0
    `,
				{
					'cursor-not-allowed bg-indow-grey-light': disabled,
				},
				{ 'border-indow-red!': error },
			]}
			{name}
			bind:checked
			{required}
			{disabled}
			{onchange}
			{...props}
		/>
		{#if typeof label === 'string'}
			<span>{label}</span>
		{:else}
			{@render label?.()}
		{/if}
	</label>
</InputWrapper>
